import type { AiAppCenterModule } from '../types'

export const tmsModule: AiAppCenterModule = {
  key: 'tms',
  label: 'AI 智慧物流',
  desc: '货主/司机/承运商三身份 · 订单运单 · 调度在途 · 签收回单 · 结算对账',
  path: '/tms',
  homePath: '/tms/identity',
  icon: 'ep:van',
  color: '#2B6DE5'
}
